module.exports = ace;


//////////////////
// WEBPACK FOOTER
// external "ace"
// module id = 17
// module chunks = 1